import Modal from 'LuxKit/Modal/Modal'
import { useIntl } from 'react-intl'
import CFMRUnforseenEventsModalContent from './CFMRUnforseenEventsModalContent'

interface Props {
  quote?: App.InsuranceQuote
}

function CFMRUnforseenEventsModal({ quote }: Props) {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'BZYBft5glUHB2a_BHVex',
    defaultMessage: 'Cancellation policy',
  })

  const subtitle = intl.formatMessage({
    id: 'cfM574oiyll_VZO5grea',
    defaultMessage: 'This exclusive protection from Luxury Escapes and XCover ensures a hassle-free 100% refund if you need to cancel for unforeseen events.',
  })

  return <Modal
    title={title}
    subtitle={subtitle}
  >
    <CFMRUnforseenEventsModalContent quote={quote} />
  </Modal>
}

export default CFMRUnforseenEventsModal
